import * as React from 'react';

const CartFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="cart-fill_svg__eds-icon--cart-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="cart-fill_svg__eds-icon--cart-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 14l2-9H7V2H2v3h4v12h14v-1H7v-1l13-1zM3 3h3v1H3V3z"
        />
        <g
            id="cart-fill_svg__eds-icon--cart-fill_circles"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M8 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM18 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
        </g>
    </svg>
);

CartFillSvg.displayName = 'CartFillSvg';
export default CartFillSvg;
